/**
 * Vehicle movement direction values
 */
export enum VehicleMovementDirectionEnum {
	INWARD = 'inward',
	OUTWARD = 'outward',
}
